import { render, staticRenderFns } from "./SalesNewCustomerNumberDisplayer.vue?vue&type=template&id=37a88f9c"
import script from "./SalesNewCustomerNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesNewCustomerNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports